import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { isDesktopCallWindow } from '../../utils/liveKitCallWindow';
import { isElectronRuntime } from '../../realm/isRealmEnabled';
import tabSessionService from '../../services/tabSessionService';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, token } = useSelector((state) => state.auth);
  const location = useLocation();
  const [tabSessionState, setTabSessionState] = useState(() => tabSessionService.getState());
  const isCallTab = isDesktopCallWindow()
    || location.pathname === '/call'
    || location.pathname.startsWith('/call/');
  const isAttendanceAnalyticsTab = location.pathname === '/attendance/analytics'
    || location.pathname.startsWith('/attendance/analytics/');

  useEffect(() => tabSessionService.subscribe(setTabSessionState), []);

  if (!isAuthenticated && !token) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // Satellite tabs / Electron shell — skip browser single-tab gate (avoids blank dark window)
  if (isCallTab || isAttendanceAnalyticsTab || isElectronRuntime()) {
    return children;
  }

  const isTabActive = tabSessionState.isLeader
    && !tabSessionState.isSuperseded
    && !tabSessionState.showSessionConflict;

  if (!isTabActive) {
    return null;
  }

  return children;
};

export default ProtectedRoute;
